import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";


import logo from "../assets/R.O.E logo White 2023 .webp";
import thaiFlag from "../assets/Flag_of_Thailand.webp";
import britishFlag from "../assets/Flag_of_England.webp";

function Navbar() {
  return (
    <div className="navbar">
      <div className="container">
        <div className="logo-container">
          <Link to="/">
            <img className="logo" src={logo} alt="London House School of English, Chiang Mai — Rocha's Overseas Education logo" />
          </Link>
          <h2>Rocha's Overseas Education</h2>
          <h1>LONDON HOUSE</h1>
          <h3>CHIANG MAI, THAILAND</h3>
        </div>

        <nav className="nav-menu">
          <ul>
            <li>
  <Link to="/" onClick={() => document.getElementById("programs").scrollIntoView({ behavior: "smooth" })}>
    Programs
  </Link>
</li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
          <div className="flag-container">
            <Link to="/HomePageTH">
              <img className="thaiFlag" src={thaiFlag} alt="ภาษาไทย — Thai language" />
            </Link>
            <Link to="/">
              <img className="britishFlag" src={britishFlag} alt="English language" />
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
